module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAUZJREFUKBVjYEAC////j/z9/v3pvz9+fALhPx8+nASKhSEpYWCEcX6/erXq+9Wrjp/27hX5ef8+WJhdSYmBz9n5LYeGxi42CYkokCBYA0gxUGHomyVLYPpRaJG4OAZeB4flbOLiUUwgZ3y7csUJpFgoMhJFIYgDEnuzaBHDj+vX3YBqQ5mA7iz6vG+fMEjy3fLlDGpbtoCYYABig8RA4NP+/cJ/378vZmHm5FSHuRkkccvHB64JxIaBn3fvMjBycmoxwQSIpZn+fv9+AxQaMAByBshkZJtAcuzKygz/v3+/xsQiINDD7+LyFiQI8iCyM0BsWEDwubq+YxYU7AYH668XL5Z9PngwEhQa2IBoQgIDj43NYjZJyTh4xP16+XIZKOhAoQHyIAiAnMEPNBlIbwUpxjAMFM5/3r07AfTXJxAGsYFiwcgKAUF4pj2JtSOtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/SmallRedTagXButton.png
// module id = 292
// module chunks = 0